module.exports = __webpack_public_path__ + "static/media/Pixel5_FR.png?v=73328863";